import { createContext } from "react";

const productsContext = createContext({
  products: [],
  getProducts: (data) => {},
  getOneProduct: (id) => {},
});

export default productsContext;
